<template>
  <b-dropdown
    class="al-dropdown"
    :text="text"
    :size="size"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
    right
    test-id="al-dropdown"
    @click="onClick"
  >
    <template v-slot:button-content>
      <slot name="button">
        <al-button
          :size="size"
          :is-icon-right="isIconRight"
          :variant="variant"
          :text="text"
          :icon="icon || `chevron-down`"
        ></al-button>
      </slot>
    </template>
    <slot />
  </b-dropdown>
</template>

<script>
import Bdropdown from 'bootstrap-vue';
import AlButton from '../form-elements/buttons/AlButton.vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Bdropdown,
    AlButton
  },
  props: {
    text: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    right: {
      type: Boolean,
      icon: false
    },
    isIconRight: {
      type: Boolean,
      icon: false
    }
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    }
  }
};
</script>

<style lang="scss">
/**
* Variables
*/
$br-radius: 4px;
$w-button: 24px;
$h-button: 24px;
$color-button: #04100f;
$bg-button-hover: #dff7ef;

$w-content: 224px;
$w-content-xs: 60px;
$p-content: 12px 0;

$box-shadow: 0 12px 8px -4px rgba(54, 64, 63, 0.1);

$p-item-menu: 6px 12px 6px;
$font-size-item-menu: 16px;
$font-color-item-menu: #68706f;
$font-color-item-menu-hover: #04100f;
$bg-color-item-menu-hover: #dff7ef;

$font-color-item-menu-disabled: #9b9f9f;
$bg-color-item-menu-disabled: #f5f8f7;

.al-dropdown {
  padding: 0;
  vertical-align: top;

  .dropdown-toggle {
    display: flex;
    padding: 0 !important;
  }

  .dropdown-menu {
    background-color: #fff;
    border: 1px solid #d9e3e2;
    border-radius: $br-radius;
    box-shadow: $box-shadow;
    list-style: none;

    margin: 4px;
    min-width: $w-content;
    padding: $p-content;
    padding-bottom: 4px;
    padding-top: 4px;

    li {
      font-size: $font-size-item-menu;
      padding: 0;

      a {
        color: $font-color-item-menu;
        display: block;
        line-height: 24px;
        padding: $p-item-menu;

        &:hover {
          background-color: $bg-color-item-menu-hover;
          color: $font-color-item-menu-hover;
          outline: none;
          text-decoration: none;
        }

        &.disabled {
          background-color: $bg-color-item-menu-disabled;
          color: $font-color-item-menu;

          &:hover {
            background-color: $bg-color-item-menu-disabled;
            color: $font-color-item-menu;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  &.xs {
    .dropdown-menu {
      min-width: $w-content-xs;
    }
  }

  .btn {
    border: 0;
  }
}
</style>
